<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1761_6661)">
      <path
        d="M3.87942 22.6324C2.90443 22.6324 1.96833 22.2288 1.22227 21.4821C-0.431936 19.8225 -0.431936 17.1232 1.22189 15.4647L14.1206 1.76749C16.1331 -0.248241 19.2158 -0.0671163 21.4655 2.18545C22.4735 3.19529 23.0392 4.65112 23.018 6.18134C22.9968 7.69541 22.4052 9.14439 21.3943 10.1571L11.6459 20.5351C11.3746 20.8259 10.9196 20.8392 10.63 20.5664C10.341 20.2933 10.327 19.8376 10.5994 19.5479L20.3626 9.15409C21.1262 8.38898 21.5643 7.30364 21.5805 6.16119C21.5966 5.01804 21.1837 3.94025 20.4491 3.20389C19.0691 1.82102 16.8223 1.09688 15.1519 2.77121L2.25361 16.4684C1.14457 17.5803 1.14493 19.3661 2.23923 20.4632C2.7524 20.9768 3.36154 21.2269 4.01021 21.1877C4.65205 21.1485 5.31186 20.8193 5.86818 20.2616L16.1312 9.33802C16.5031 8.96535 17.2506 8.05182 16.4898 7.28922C16.059 6.85761 15.7564 6.88421 15.6568 6.89247C15.3726 6.91763 15.0405 7.11421 14.6959 7.45993L6.9711 15.6756C6.69833 15.9656 6.24301 15.9796 5.95512 15.7061C5.66583 15.4337 5.65253 14.9773 5.92458 14.6884L13.6634 6.45727C14.2718 5.84597 14.8939 5.51463 15.5271 5.45785C16.0213 5.41398 16.7562 5.5193 17.5058 6.27111C18.6185 7.38587 18.4801 9.02105 17.1626 10.3414L6.89961 21.2642C6.08023 22.0865 5.09085 22.5641 4.09826 22.6251C4.0253 22.6302 3.95235 22.6323 3.8794 22.6323L3.87942 22.6324Z"
        fill="#919191"
      />
    </g>
    <defs>
      <clipPath id="clip0_1761_6661">
        <rect width="23" height="23" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
